import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import authInstance from '../../config/authInstance';
import timeclockInstance from '../../config/timeclockInstance';
import axios from 'axios';

export const fetchUserSuccess = user => ({
  type: actions.FETCH_USER_SUCCESS,
  user,
});

export const fetchUser = cpf => (dispatch) => {
  dispatch({ type: actions.FETCH_USER_START });
  return timeclockInstance
    .get(`/record-reg/companies/${cpf}`)
    .then((response) => {
      if (!response.data.hasUser) {
        if (response.data.employeeName) {
          dispatch(setMessage('Você ainda não é registrado. Por favor registre-se para bater o ponto.'));
        } else {
          dispatch(setMessage('CPF não encontrado.'));
        }
      }
      dispatch(fetchUserSuccess(response.data));
      dispatch({ type: actions.FETCH_USER_END });
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch({ type: actions.FETCH_USER_END });
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const clockInOutSuccess = () => ({
  type: actions.CLOCK_IN_OUT_SUCCESS,
});

export const clockInOut = (data, token) => (dispatch) => {
  dispatch(setLoading(true));
  return timeclockInstance
    .post('/record-reg/register/timeclock/web', data, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => {
      dispatch(clockInOutSuccess(response.data));
      dispatch(setLoading(false));
      // dispatch(setMessage('Ponto batido com sucesso.'));
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
      return Promise.reject(error);
    });
};

export const clockInOutNew = (data, token) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.post('https://puntuapi.eastus.cloudapp.azure.com/api/record/timeclock', data, {
      headers: { Authorization: `Bearer ${token}` }
    });
    dispatch(clockInOutSuccess(response.data));
    dispatch(setLoading(false));
    // dispatch(setMessage('Ponto batido com sucesso.'));
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    return error.response.data.message
    // dispatch(setMessage(error));
    // throw error;
  }
};

export const downloadReceipt = timeclockId => (dispatch) => {
  dispatch(setLoading(true));
  timeclockInstance
    .post(`/record-reg/checkingCopy/${timeclockId}`, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      dispatch(setLoading(false));
      // fileDownload(response.data, 'Relatório Espelho de Ponto.pdf');
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const sendEmail = (timeclockId, token) => (dispatch) => {
  dispatch(setLoading(true));
  timeclockInstance
    .get(`/record-reg/sendEmailReceipt/${timeclockId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const registerEmployee = employee => (dispatch) => {
  dispatch(setLoading(true));
  const path = employee.gestor ? '/authentication/register/manager' : '/authentication/register';
  // const instance = employee.gestor ? authInstance : timeclockInstance;
  const instance = authInstance;
  return instance
    // auth/users/asManager
    .post(path, employee)
    .then((response) => {
      dispatch(setLoading(false));
      dispatch(setMessage('Cadastro realizado com sucesso'));
      return Promise.resolve(response);
    })
    .catch((error) => {
      dispatch(setLoading(false));

      if (error === 'Erro de validação email must be unique') {
        dispatch(setMessage('Este email já está em uso'));
      } else {
        dispatch(setMessage(error));
      }
      return Promise.reject(error);
    });
};
